import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class OrganizationSettingsApi {
  static getPaymentRailSetting = (organizationId) =>
    axios.get(
      `${API_BASE_URL}/settings/organization/${organizationId}/payment-rail-setting`,
    );
}
